import React, { useState, useEffect } from "react";
import { createArena, fetchTournaments } from "../api/api";
import {
    getTournamentData,
    buildTournamentMap,
    getTournamentDisplayName
} from "../utils/tournamentUtils";

const AdminSquadCard = ({ squad, onArenaCreated }) => {

    const [selectedTournaments, setSelectedTournaments] = useState([]);
    const [creatingArena, setCreatingArena] = useState(false);
    const [tournaments, setTournaments] = useState([]);
    const [error, setError] = useState(null);

    const tournamentMap = buildTournamentMap(tournaments);

    const toggleTournament = (tournamentId) => {
        if (selectedTournaments.includes(tournamentId)) {
            setSelectedTournaments(
                selectedTournaments.filter((id) => id !== tournamentId)
            );
        } else {
            setSelectedTournaments([
                ...selectedTournaments,
                tournamentId
            ]);
        }
    };

    const handleCreateArena = async () => {
        if (selectedTournaments.length === 0) {
            setError("Select at least one tournament");
            return;
        }

        try {
            setCreatingArena(true);
            setError(null);

            await createArena(
                squad.slug,
                selectedTournaments
            );

            setSelectedTournaments([]);

            await onArenaCreated();

        } catch (err) {
            setError(err.message);
        } finally {
            setCreatingArena(false);
        }
    };

    useEffect(() => {
        const initialize = async () => {
            const { tournaments } =
                await getTournamentData(
                    fetchTournaments
                );

            setTournaments(tournaments);
        };

        initialize();
    }, []);

    return (
        <div className="squad-card">

            <div className="squad-header">

                <div className="squad-card-left">
                    <img
                        src={squad.countryFlag}
                        alt={squad.country}
                        title={squad.country}
                        className="squad-country-flag"
                    />
                </div>

                <div className="squad-card-right">

                    <div className="squad-name-row">

                        <div className="squad-name">
                            {squad.name}
                        </div>

                        <span className="admin-badge">
                            ADMIN
                        </span>
                    </div>

                    <div className="squad-admin">
                        code: {squad.code}
                    </div>

                    <div className="squad-code">
                        arenas: {squad.arenas.length}/5
                    </div>
                </div>
            </div>

            <div className="arenas-container">

                {squad.arenas.map((arena) => (
                    <div
                        key={arena.id}
                        className="arena-card"
                    >

                        <div className="arena-title">
                            Arena #{arena.id}
                        </div>

                        <div className="arena-tournaments">
                            {arena.enabledTournaments
                                .map((t) => {
                                    const tournament = tournamentMap[t.id];

                                    if (!tournament) {
                                        return null;
                                    }

                                    return `${getTournamentDisplayName(tournament.name)} ${tournament.season}`;
                                })
                                .filter(Boolean)
                                .join(", ")
                            }
                        </div>

                        <div className="arena-users-count">
                            👥 {arena.joinedUsersCount} users
                        </div>
                    </div>
                ))}
            </div>

            {squad.arenas.length < 5 ? (
                <div className="create-arena-form">

                    <div className="create-arena-title">
                        Create Arena
                    </div>

                    <div className="tournament-checkboxes">

                        {tournaments.map((tournament) => (
                            <label
                                key={tournament.id}
                                className="tournament-checkbox-item"
                            >

                                <input
                                    type="checkbox"
                                    checked={selectedTournaments.includes(tournament.id)}
                                    onChange={() =>
                                        toggleTournament(tournament.id)
                                    }
                                />

                                {`${getTournamentDisplayName(tournament.name)} ${tournament.season}`}
                            </label>
                        ))}
                    </div>

                    {error && (
                        <p className="alert-text">
                            {error}
                        </p>
                    )}

                    <button
                        className="submit-button create-arena-button"
                        onClick={handleCreateArena}
                        disabled={creatingArena}
                    >
                        {creatingArena
                            ? "Creating..."
                            : "Create Arena"}
                    </button>
                </div>
            ) : (
                <p className="alert-text">
                    Maximum arenas reached.
                </p>
            )}
        </div>
    );
};

export default AdminSquadCard;